module.exports = __webpack_public_path__ + "static/media/banner.bc62a5f0.png";